import { Component, OnInit, OnDestroy } from '@angular/core';
import { FirebaseService } from '../../service/firebase.service';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';
import { ContactModel } from '@shared/models/contact.model';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  providers: [FirebaseService]
})
export class ContactComponent implements OnInit, OnDestroy {

  form: FormGroup;
  error: string;
  sucsess: string;
  sending = false;
  subscriptions: Subscription;
  errSubscriptions: Subscription;
  proccessSubscription: Subscription;
  get contactFormControls() {
    return this.form.controls;
  }

  constructor(
    private formBuilder: FormBuilder,
    private firebaseService: FirebaseService) {
    this.subscriptions = this.firebaseService.sendEmailSuccess$.subscribe(mes => this.sucsess = mes);
    this.errSubscriptions = this.firebaseService.sendEmailErr$.subscribe(err => this.error = err);
    this.proccessSubscription = this.firebaseService.emailSendingInProcess$.subscribe(inProcess => this.sending = inProcess);
  }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.compose([Validators.required, Validators.minLength(9), Validators.pattern(/^[0-9\s]*$/)])],
      subject: ['', [Validators.required]],
      message: ['', [Validators.required]],
    });
  }

  send() {
    if (this.form.valid) {
      this.firebaseService.sendEmail(this.form.value);
    }
  }

  getNameError() {
    if (this.form.controls.name.errors) {
      if (this.form.controls.name.errors.required) {
        return 'שדה חובה';
      } else if (this.form.controls.name.errors.minlength) {
        return 'מינימום 2 אותיות';
      }
    }
  }

  getEmailError() {
    if (this.form.controls.email.errors) {
      if (this.form.controls.email.errors.required) {
        return 'שדה חובה';
      } else if (this.form.controls.email.errors.email) {
        return 'דוא"ל לא תקין';
      }
    }
  }

  getPhoneError() {
    if (this.form.controls.phone.errors) {
      if (this.form.controls.phone.errors.required) {
        return 'שדה חובה';
      } else if (this.form.controls.phone.errors.minlength) {
        return 'מינימום 9 מספרים';
      } else if (this.form.controls.phone.errors.pattern) {
        return 'טלפון לא תקין';
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.errSubscriptions.unsubscribe();
    this.proccessSubscription.unsubscribe();
  }

}
